import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import InvitePlayerModal from '../../../components/playerInvites/InvitePlayerModal';

const Muted = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.45;
`;

const OpenBtn = styled.button`
  padding: 0.6rem 1rem;
  border: none;
  border-radius: 8px;
  background: #043663;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
`;

export default function HelpInvitePlayerPanel({ teamContext }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const teamId = teamContext?.teamId;
  const teamName = teamContext?.teamName || teamContext?.rosterRow?.teamName;

  if (!teamId) {
    return <Muted>{t('phase2.playerHelpWizard.invitePlayer.pickTeamFirst')}</Muted>;
  }

  return (
    <>
      <Muted>{t('phase2.playerHelpWizard.invitePlayer.hint')}</Muted>
      <OpenBtn type="button" onClick={() => setOpen(true)}>
        {t('phase2.playerHelpWizard.invitePlayer.openSearch')}
      </OpenBtn>
      {open ? (
        <InvitePlayerModal
          teamId={teamId}
          teamName={teamName}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
